const myStyles = theme => ({
  content: {
    padding: "72px 8px 8px 8px",
    "@media (min-width:0px) and (orientation: landscape)": {
      padding: "72px 8px 8px 8px"
    },

    "@media (min-width:600px)": {
      padding: "72px 8px 8px 8px",
      marginLeft: "321px",
      width: "calc(100% - 321px)"
    },
    width: "100%",
    height: "100vh"
  },
  msgLoad: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)"
  }
});

export default myStyles;
